import { TemplateState } from '../templateeditor-types';

export type TemplateMeta = {
  id: string;
  name: string;
};

export function getTemplateMeta(state: TemplateState): TemplateMeta {
  const { template } = state;

  return {
    id: template?.id || '',
    name: template?.name || ''
  };
}

export function getAiMetricsAndFields(state: TemplateState) {
  if (!state.template?.isNew) {
    // explicit
    return {
      aiMetrics: undefined,
      transientAiFields: []
    };
  }

  const aiMetrics = state?.template?.aiMetrics;
  const transientAiFields =
    state?.template?.fields
      ?.filter((field) => field.isAiPlaced)
      .map((field) => ({
        id: field.id,
        isAiPlaced: field.isAiPlaced,
        aiCheckboxGroupProperties: field.aiCheckboxGroupProperties
      })) || [];

  return {
    aiMetrics,
    transientAiFields
  };
}
